<template>
  <span class="mail-send-status">
    <span v-tooltip="{ title: dotTooltip }" class="mail-send-status__dot" :class="dotClass" aria-hidden="true"></span>
    <span class="visually-hidden">{{ dotTooltip }}</span>
  </span>
</template>

<script>
import { mailStatusManager } from "@/services/mail-status/mail-status-manager";

export default {
  name: "MailSendStatusDotComponent",
  props: {
    variant: {
      type: String,
      required: true,
      validator: (value) => ["pending", "success", "warning", "danger", "error", "unknown"].includes(value),
    },
  },
  computed: {
    dotClass() {
      return mailStatusManager.getSendDotClass(this.variant);
    },
    dotTooltip() {
      return this.$t(mailStatusManager.getSendDotTooltipKey(this.variant));
    },
  },
};
</script>

<style lang="scss" scoped>
.mail-send-status {
  display: inline-flex;
  align-items: center;

  &__dot {
    display: block;
    width: 15px;
    height: 15px;
    border-radius: 50%;
    box-sizing: border-box;

    &.-pending {
      background: transparent;
      border: 2px solid $d-success;

      @include dark-theme {
        border-color: $l-success;
      }
    }

    // Les utilitaires bg-success / bg-warning n'atteignent pas les 3:1 exigés sur fond clair
    // (RGAA 4.1.2, critère 3.2) : nuance assombrie en thème clair uniquement.
    &.bg-success {
      background-color: $d-success !important;

      @include dark-theme {
        background-color: $success !important;
      }
    }

    &.bg-warning {
      background-color: $d-warning !important;

      @include dark-theme {
        background-color: $warning !important;
      }
    }
  }
}
</style>
